$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.slick({
            fade: true,
            dots: false,
            arrows: false,
            autoplay: true,
            speed: 300,
            autoplaySpeed: 2000,
            pauseOnHover: false,
            prevArrow: $(".js-hero-slider-nav-prev"),
            nextArrow: $(".js-hero-slider-nav-next"),
            dotsClass: "heroSlider__dots",
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });
    }


    $(".gallery__items").slick({
        fade: true,
        dots: true,
        arrows: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        prevArrow: "<img class='slick-prev-custom' src='assets/website/img/slider-left.svg' alt='left arrow'>",
        nextArrow: "<img class='slick-next-custom' src='assets/website/img/slider-right.svg' alt='right arrow'>",
        dotsClass: "gallery__dots"
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll to top
    // *
    // *

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.js-scrolltop').fadeIn();
        } else {
            $('.js-scrolltop').fadeOut();
        }
    });

    $('.js-scrolltop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page

    $(".js-hero-scrolldown").click(function () {
        var heightheader = $(".header").height();
        if ($(window).width() < 600) {
            $('html, body').animate({

                scrollTop: $(this).offset().top + heightheader - 20
            }, 1000);
        }
        else {
            $('html, body').animate({

                scrollTop: $(this).offset().top + heightheader + 40
            }, 1000);
        }

        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Link in a new window
    // *
    // *

    $('a[rel*="external"]').click(function () {
        $(this).attr('target', '_blank');
    });

    $('.footer__navleft').click(function () {
        $('body').toggleClass('freeze');
        $('.footer').toggleClass('show');

        if ($('.footer').hasClass('show')) {
            stopScroll();
        } else {
            enableScroll();
        };

    });

    $('.header__menu').click(function () {
        $('.header__nav').toggleClass('show');
    });
    $('.header__close').click(function () {
        $('.header__nav').toggleClass('show');
    });


    $(document).on("click", ".header__nav.show ul li a", function (event) {
        setTimeout(function () {
            $('.header__nav').toggleClass('show');
        }, 800);

    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash scrollto
    // *
    // *

    /*
    $(window).on('load', function() {
        var myhash = window.location.hash;
        if(myhash.length != "") {
            var name = "#my" + myhash.slice(1);
            $("body,html").animate({ scrollTop: $(name).offset().top }, 1200);
        }
    });
    */
    // Cache selectors
    // Cache selectors
    var lastId,
        topHeader = $('.header'),
        topHeaderHeight = topHeader.outerHeight(),
        topMenu = $(".header__nav ul"),
        topMenuHeight = topMenu.outerHeight() + 15,
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function () {
            var item = $($(this).attr("href"));
            if (item.length) { return item; }
        });

    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems.click(function (e) {
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top - topHeaderHeight + 1;
        $('html, body').stop().animate({
            scrollTop: offsetTop
        }, 700);
        e.preventDefault();
    });

    // Bind to scroll
    $(window).scroll(function () {
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topHeaderHeight;

        // Get id of current scroll item
        var cur = scrollItems.map(function () {
            if ($(this).offset().top < fromTop)
                return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";

        if (lastId !== id) {
            lastId = id;
            // Set/remove active class
            menuItems
                .parent().removeClass("active")
                .end().filter("[href='#" + id + "']").parent().addClass("active");
        }
    });




    var disableScroll = false;
    var scrollPos = 0;
    function stopScroll() {
        disableScroll = true;
        scrollPos = $(window).scrollTop();
    }
    function enableScroll() {
        disableScroll = false;
    }
    $(function () {
        $(window).bind('scroll', function () {
            if (disableScroll) $(window).scrollTop(scrollPos);
        });
        $(window).bind('touchmove', function () {
            $(window).trigger('scroll');
        });
    });


    var footerheight = $('.footer').outerHeight();
    footerheight = footerheight + $(window).height();

    $(window).scroll(function () {
        var height = $('body').height() - footerheight;
        if (!$('footer').hasClass('show')) {
            if ($(this).scrollTop() > height) {
                $('.footer__navleft img').hide();
                $('.footer__navleft span').hide();
            } else {
                $('.footer__navleft img').show();
                $('.footer__navleft span').show();
            }

        }
    });
});





